import { useEffect, useState } from "react";
import { useStore, useStoreApi } from '@hmpu/powerups.store';
import { useTranslate } from '@hmpu/powerups.intl.legacy.hooks.use-translate';
import { useSkipChapter } from '@hmpu/powerups.vie.hooks.use-skip-chapter';
import "./Onboarding.css";
import useResetFocus from '../../hooks/useResetFocus';
import CircleButton from "../../components/CircleButton";
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { useVieConfig } from '@hmpu/powerups.vie.hooks.use-vie-config';

export const Onboarding = (props) => {
  const { subscribe } = useStoreApi();
  const translate = useTranslate();
  const currentVIEConfig = useStore((state) => state.currentVIEConfig)
  const setCurrentVIEConfig = useStore((state) => state.setCurrentVIEConfig);
  const setShowSkip = useStore((state) => state.setShowSkip);
  const[isNavBarTopPositioned, setIsNavBarTopPositioned] = useState(true);

  const parentNode = "ONBOARDING";
  const skipChapter = useSkipChapter();
  const { __t } = useTranslation(parentNode);
  const pageTitle = translate('pageTitle', parentNode);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const inPortrait = useStore((state) => state.inPortrait);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const confirmAria = translate('confirmButton', parentNode);
  const confirmAriaLabel = confirmAria.ariaLabel;
  const replayAria = translate('replayButton', parentNode);
  const replayAriaLabel = replayAria.ariaLabel;
  const currentCueMetadata = useStore((state) => state.currentCueMetadata);
  const [showConfirmAndReplay, setShowConfirmAndReplay] = useState(false);
  const { vieConfigRef, updateVieConfig } = useVieConfig();

  const introText = translate('text1', parentNode);
  const [introText1, setIntroText1] = useState("");
  const [introText2, setIntroText2] = useState("");
  const [introText3, setIntroText3] = useState("");
  const [showIntroOnboardingCopy, setShowIntroOnboardingCopy] = useState(true);

  useResetFocus([showSettingsPanel, inPortrait, isPauseEnabled, skipChapter]);

  useEffect(() => {
    setPageTitle(pageTitle);
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);

  useEffect(() => {
    const introCopy = introText.split('\n');
    setIntroText1(introCopy[0]);
    setIntroText2(introCopy[1] || '');
    setIntroText3(introCopy[2] || '');
  }, [])

  useEffect(() => {
    let vieConfig = { ...vieConfigRef.current || __t("vieConfig") };
    vieConfig.skipChapter = null;

    vieConfig.overlays = showConfirmAndReplay ? (
        <>
          <div className="onboarding-header">
            <h1>{__t('h1')}</h1>
          </div>
          <section className="onboarding-ctas">
            <div className="replay-btn onboarding-btn">
              <CircleButton
                  variant="dark"
                  ariaLabel={replayAriaLabel}
                  icon={'replay'}
                  onClick={(e) => {
                    setShowConfirmAndReplay(false);
                    updateVieConfig({...vieConfigRef.current, skipChapter: "CHAPTER_REPLAY"})
                  }
                  }
              />
            </div>

            <div className="confirm-btn onboarding-btn">
              <CircleButton
                  variant="dark"
                  ariaLabel={confirmAriaLabel}
                  icon={'confirm'}
                  onClick={(e) => {
                    setShowConfirmAndReplay(false);
                    updateVieConfig({...vieConfigRef.current, parentNode, skipChapter: "CHAPTER_OUTRO"})
                  }
                  }
              />
            </div>
            <div className="CircleButton"></div>
          </section>
        </>) : null;

    updateVieConfig(vieConfig)

  }, [showConfirmAndReplay])

  useEffect(() => {
    if(currentCueMetadata?.id === "CHAPTER_HOLD") {
      setShowConfirmAndReplay(true);
    }
  }, [currentCueMetadata])

  useEffect(() => {
    if(currentCueMetadata?.id === "CHAPTER_ONBOARDING_INTRO_CONTENT_OUT" || currentCueMetadata?.id === "CHAPTER_HOLD" || currentCueMetadata?.id === "TRIGGER_CONTENT_IN") {
      setShowIntroOnboardingCopy(false);
    }
  }, [currentCueMetadata])


  useEffect(() => {
    const unsub = subscribe(
      (state) => state.skipTarget,
      (skipTarget, prevSkipTarget) => {
        setIsNavBarTopPositioned(skipTarget);
      }
    );
    return () => {
      unsub();
    };
  }, [subscribe]);

  useEffect(() => {
    //debugger;
    let vieConfig = { ...vieConfigRef.current || __t("vieConfig")};
    vieConfig.skipChapter = skipChapter;
    updateVieConfig(vieConfig)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skipChapter]);

  return (
    <>
      {
        showIntroOnboardingCopy ? (
          <div className="onboarding-intro-copy">
            <p className="HeaderH2">{introText1}</p>
            <p className="HeaderH2">{introText2}</p>
            <p className="HeaderH2">{introText3}</p>
          </div>
        ) : null
      }
    </>
  );
}

export default Onboarding;
